// extracted by mini-css-extract-plugin
module.exports = {"dateRange":"DateRanges_dateRange__rh5lb"};